import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Container } from 'theme-ui';
import { ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import { AppContext } from '../../contexts/AppContext';

type NavbarProps = {
  children?: React.ReactNode;
};

const Navbar = ({ children }: NavbarProps) => {
  const { i18n, t } = useTranslation();
  const { settings, partner } = useContext(AppContext);
  const [languages, setLanguages] = useState<{ key: string; label: string }[]>([]);
  const [selectedLanguage, setSelectedLanguage] = useState('sv');

  const handleLocaleChange = async (language: string = 'sv') => {
    await i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  };

  useEffect(() => {
    if (settings?.locales) {
      let languageList = Object.keys(settings?.locales).map((locale) => ({
        key: locale,
        label: locale.toUpperCase()
      }));

      setLanguages(languageList);

      if (languageList.length > 0) {
        const selectedLan = localStorage.getItem('language');

        if (selectedLan && languageList.find((lang) => lang.key === selectedLan)) {
          i18n.changeLanguage(selectedLan).then(() => setSelectedLanguage(selectedLan));
        } else {
          i18n.changeLanguage(languageList[0].key).then(() => {
            setSelectedLanguage(languageList[0].key);
            localStorage.setItem('language', languageList[0].key);
          });
        }
      } else {
        i18n.changeLanguage('sv').then(() => setSelectedLanguage('sv'));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  return (
    <Fragment>
      <Flex className="navbar">
        <Flex
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexShrink: 0
          }}
        >
          <div className="navbar__text">{t('navHeader') + (settings?.displayName || partner?.name || 'Velove')}</div>
          <img className="bike__logo" alt="bike_logo" />
        </Flex>
        <Flex className="dropdown-container">
          <Container sx={{ display: 'flex', flexDirection: 'row' }}>
            <DropdownButton
              as={ButtonGroup}
              size="sm"
              variant="outline-dark"
              title={selectedLanguage.toUpperCase()}
              onSelect={async (data) => {
                setSelectedLanguage(data || 'sv');
                await handleLocaleChange(data || 'sv');
              }}
            >
              {languages.map((language) => {
                return (
                  <Dropdown.Item key={language.key} eventKey={language.key} active={selectedLanguage === language.key}>
                    {language.label}
                  </Dropdown.Item>
                );
              })}
            </DropdownButton>
          </Container>
        </Flex>
      </Flex>
      {children}
    </Fragment>
  );
};

export default Navbar;
